import React from 'react';
import TabLinkUI from '../../../widgets/output/TabLinkUI';

const RetailRepaymentNavUI = ({ context, page }) =>
  <div>
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      <TabLinkUI
        label='Non Retail'
        to={`/su/compliance`}
        active={page === 'compliance'}
      />
      <TabLinkUI
        label='Retail'
        to={`/su/compliance/retail`}
        active={page === 'compliance_retail'}
      />
    </div>
    <div className='g_m_top_50' />
  </div>

export default RetailRepaymentNavUI
